import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["linkIcon"];
var _sizeToButtonSpacing, _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { css } from '@emotion/react';
import { FormattedMessage } from 'react-intl-next';
import { SmartLinkSize } from '../../../constants';
import Icon from './elements/icon';
import { openEmbedModal } from '../../EmbedModal/utils';
export var sizeToButtonSpacing = (_sizeToButtonSpacing = {}, _defineProperty(_sizeToButtonSpacing, SmartLinkSize.Small, 'none'), _defineProperty(_sizeToButtonSpacing, SmartLinkSize.Medium, 'compact'), _defineProperty(_sizeToButtonSpacing, SmartLinkSize.Large, 'compact'), _defineProperty(_sizeToButtonSpacing, SmartLinkSize.XLarge, 'default'), _sizeToButtonSpacing);
export var getFormattedMessage = function getFormattedMessage(message) {
  if (message) {
    var descriptor = message.descriptor,
      values = message.values;
    return /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, descriptor, {
      values: values
    }));
  }
};
export var getFormattedMessageAsString = function getFormattedMessageAsString(intl, message, context) {
  var formatMessage = intl.formatMessage;
  return message ? formatMessage(message, {
    context: context
  }) : '';
};
var getIconDimensionStyles = function getIconDimensionStyles(value) {
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: ", ";\n  min-height: ", ";\n  max-height: ", ";\n  width: ", ";\n  min-width: ", ";\n  max-width: ", ";\n"])), value, value, value, value, value, value);
};
export var getIconSizeStyles = function getIconSizeStyles(width) {
  var sizeStyles = getIconDimensionStyles(width);
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    flex: 0 0 auto;\n    ", "\n    span,\n    svg,\n    img {\n      ", "\n    }\n    svg {\n      padding: 0;\n    }\n  "])), sizeStyles, sizeStyles);
};
export var getIconWidth = function getIconWidth(size) {
  switch (size) {
    case SmartLinkSize.XLarge:
      return '2rem';
    case SmartLinkSize.Large:
      return '1.5rem';
    case SmartLinkSize.Medium:
      return '1rem';
    case SmartLinkSize.Small:
    default:
      return '.75rem';
  }
};
export var getLinkLineHeight = function getLinkLineHeight(size) {
  switch (size) {
    case SmartLinkSize.XLarge:
      return '1.5rem';
    case SmartLinkSize.Large:
    case SmartLinkSize.Medium:
    case SmartLinkSize.Small:
    default:
      return '1rem';
  }
};
export var getLinkSizeStyles = function getLinkSizeStyles(size) {
  switch (size) {
    case SmartLinkSize.XLarge:
      return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        font-size: 1.25rem;\n        font-weight: 400;\n        letter-spacing: -0.008em;\n        line-height: ", ";\n      "])), getLinkLineHeight(size));
    case SmartLinkSize.Large:
    case SmartLinkSize.Medium:
      return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n        font-size: 0.875rem;\n        font-weight: 400;\n        letter-spacing: -0.003em;\n        line-height: ", ";\n      "])), getLinkLineHeight(size));
    case SmartLinkSize.Small:
    default:
      return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n        font-size: 0.75rem;\n        font-weight: 400;\n        letter-spacing: 0em;\n        line-height: ", ";\n      "])), getLinkLineHeight(size));
  }
};
export var getMaxLineHeight = function getMaxLineHeight(size) {
  // The maximum line height based on all elements in specific size.
  // These heights belongs to AvatarGroup.
  switch (size) {
    case SmartLinkSize.XLarge:
    case SmartLinkSize.Large:
      return 1.75;
    case SmartLinkSize.Medium:
    case SmartLinkSize.Small:
    default:
      return 1.5;
  }
};
export var getMaxLines = function getMaxLines(value, defaultValue, max, min) {
  if (value > max) {
    return defaultValue;
  }
  if (value < min) {
    return min;
  }
  return value;
};
export var getTruncateStyles = function getTruncateStyles(maxLines) {
  var lineHeight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1rem';
  var wordBreak = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'break-word';
  return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    display: -webkit-box;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    word-break: ", ";\n    -webkit-line-clamp: ", ";\n    -webkit-box-orient: vertical;\n    // Fallback options\n    @supports not (-webkit-line-clamp: 1) {\n      max-height: calc(", " * ", ");\n    }\n  "])), wordBreak, maxLines, maxLines, lineHeight);
};
export var hasWhiteSpace = function hasWhiteSpace(str) {
  return str.search(/\s/) >= 0;
};
export var openEmbedModalWithFlexibleUiIcon = function openEmbedModalWithFlexibleUiIcon(_ref) {
  var linkIcon = _ref.linkIcon,
    props = _objectWithoutProperties(_ref, _excluded);
  var icon = {
    icon: /*#__PURE__*/React.createElement(Icon, _extends({}, linkIcon, {
      size: SmartLinkSize.Large
    })),
    isFlexibleUi: true
  };
  return openEmbedModal(_objectSpread(_objectSpread({}, props), {}, {
    icon: icon,
    // Flex should not send origin as block card. It should be able to support
    // its internal parent components like hover card, block card and
    // itself as a standalone. To be investigated and fix in EDM-7520.
    origin: 'smartLinkCard'
  }));
};